import { useState, useEffect } from "react";
import QuotationDashboard from "./QuotationDashboard";
import QuotationList from "./QuotationList";
import QuotationCreate from "./QuotationCreate";
import QuotationDetail from "./QuotationDetail";
import QuotationConfig from "./QuotationConfig";
import { ChartBar, List, Gear } from "@phosphor-icons/react";

export default function QuotationModule({ token, user, prefillData, onClearPrefill, viewDetailId, onClearViewDetail }) {
  const isAdminInit = user?.role === "admin";
  const [view, setView] = useState(isAdminInit ? "dashboard" : "list");
  const [listFilter, setListFilter] = useState("todos");
  const [editId, setEditId] = useState(null);
  const [detailId, setDetailId] = useState(null);
  const [activeTab, setActiveTab] = useState(isAdminInit ? "dashboard" : "list");
  const [activePrefill, setActivePrefill] = useState(null);

  useEffect(() => {
    if (prefillData) {
      setActivePrefill(prefillData);
      setView("create");
      setEditId(null);
      if (onClearPrefill) onClearPrefill();
    }
  }, [prefillData, onClearPrefill]);

  useEffect(() => {
    if (viewDetailId) {
      setDetailId(viewDetailId);
      setView("detail");
      if (onClearViewDetail) onClearViewDetail();
    }
  }, [viewDetailId, onClearViewDetail]);

  const handleNavigate = (target, filter, id) => {
    if (target === "dashboard") { setView("dashboard"); setActiveTab("dashboard"); }
    else if (target === "list") { setView("list"); setActiveTab("list"); if (filter) setListFilter(filter); else setListFilter("todos"); }
    else if (target === "create") { setView("create"); setEditId(null); setActivePrefill(null); }
    else if (target === "edit") { setView("create"); setEditId(id); setActivePrefill(null); }
    else if (target === "detail") { setView("detail"); setDetailId(id); }
    else if (target === "config") { setView("config"); setActiveTab("config"); }
  };

  const isAdmin = user?.role === "admin";

  const tabs = [
    ...(isAdmin ? [{ id: "dashboard", label: "Dashboard", icon: ChartBar }] : []),
    { id: "list", label: "Presupuestos", icon: List },
    ...(isAdmin ? [{ id: "config", label: "Configuracion", icon: Gear }] : []),
  ];

  // If not admin and view is dashboard, redirect to list
  const effectiveView = (!isAdmin && view === "dashboard") ? "list" : view;

  return (
    <div className="space-y-4" data-testid="quotation-module">
      {/* Tab bar */}
      {view !== "create" && view !== "detail" && (
        <div className="flex gap-1 bg-slate-100 rounded-lg p-1 w-fit">
          {tabs.map(tab => {
            const Icon = tab.icon;
            return (
              <button key={tab.id} onClick={() => handleNavigate(tab.id)}
                className={`flex items-center gap-1.5 px-4 py-2 rounded-md text-sm font-medium transition-colors ${activeTab === tab.id ? "bg-white text-blue-600 shadow-sm" : "text-slate-500 hover:text-slate-700"}`}
                data-testid={`quotation-tab-${tab.id}`}>
                <Icon size={16} /> {tab.label}
              </button>
            );
          })}
        </div>
      )}

      {effectiveView === "dashboard" && isAdmin && <QuotationDashboard token={token} onNavigate={handleNavigate} />}
      {effectiveView === "list" && <QuotationList token={token} onNavigate={handleNavigate} initialFilter={listFilter} />}
      {effectiveView === "create" && <QuotationCreate token={token} onNavigate={handleNavigate} editId={editId} prefillData={activePrefill} />}
      {effectiveView === "detail" && <QuotationDetail token={token} quotationId={detailId} onNavigate={handleNavigate} />}
      {effectiveView === "config" && isAdmin && <QuotationConfig token={token} user={user} />}
    </div>
  );
}
